import "./frequencyCell.scss";

const FrequencyCell = ({ value, ...props }) => {
  return (
    <div className="frequencyCell">{props.row.original.frequency_value}</div>
  );
};

export default FrequencyCell;
